var _filter, _g, _circle, _ellipse, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun02d",
    cx: "50%",
    cy: "30%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFE066",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FF8C42",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud02d",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#E2E8F0",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "cloudShadow02d"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#94A3B8",
    floodOpacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFE066",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 15,
    x2: 30,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 30,
    x2: 22,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 19.5,
    x2: 24.5,
    y2: 24.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 15,
    fill: "url(#sun02d)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 55,
    rx: 18,
    ry: 12,
    fill: "url(#cloud02d)",
    filter: "url(#cloudShadow02d)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 50,
    r: 8,
    fill: "url(#cloud02d)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 10,
    fill: "url(#cloud02d)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 45,
    r: 7,
    fill: "url(#cloud02d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D);
export default __webpack_public_path__ + "static/media/02d.80e4fcf0131f79384cd5ea550703113e.svg";
export { ForwardRef as ReactComponent };